import { styled } from '@mui/material'

const DetailsList = styled('dl')({
  margin: 0,
  marginBlock: 0,
  marginInline: 0,
  padding: 0,
  marginBottom: '2rem',
})

export default DetailsList
